module.exports = __webpack_public_path__ + "img/wind-solar-graph-lg.57a33d02.png";